const NotFound = ()=>{
return(
<>
    <h1>NotFound.js</h1>
</>
)
};

export default NotFound;